import Head from 'next/head'
import {
    ComponentType,
    createElement,
    Fragment,
    PropsWithChildren,
} from 'react'
import { createPageTitle } from '../../utilities/pageMetadata'
import { usePassive } from '../Hooks/usePassive'

export function withTitle(
    Component: ComponentType<any>,
    titleOrGenerator:
        | string
        | ((props: PropsWithChildren<any>) => string | ComponentType<any>),
) {
    return (props: PropsWithChildren<any>) => {
        const passiveMode = usePassive()
        const finalTitle =
            typeof titleOrGenerator === 'string'
                ? titleOrGenerator
                : titleOrGenerator(props)
        const nextTitle = createPageTitle(finalTitle)
        return (
            <Fragment>
                {!passiveMode && (
                    <Head>
                        {typeof finalTitle === 'string' && (
                            <title>{nextTitle}</title>
                        )}
                        {finalTitle &&
                            typeof finalTitle !== 'string' &&
                            createElement(finalTitle, props)}
                    </Head>
                )}
                <Component {...props} />
            </Fragment>
        )
    }
}
